import * as Types from '../../../../../../../__generated__/schema';

import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ListAvailableLogProvidersVariables = Types.Exact<{ [key: string]: never }>;

export type ListAvailableLogProviders = {
  listAvailableLogProviders: {
    results?: Types.Maybe<
      Array<
        Pick<
          Types.AvailableLogProvider,
          | 'id'
          | 'displayName'
          | 'docUrl'
          | 'popularityIndex'
          | 'categories'
          | 'searchTerms'
          | 'tagLine'
          | 'transports'
        > & { availableParsers: Array<Pick<Types.AvailableLogProviderParser, 'name'>> }
      >
    >;
    error?: Types.Maybe<Pick<Types.Error, 'message'>>;
  };
};

export const ListAvailableLogProvidersDocument = gql`
  query ListAvailableLogProviders {
    listAvailableLogProviders {
      results {
        id
        displayName
        docUrl
        popularityIndex
        categories
        searchTerms
        tagLine
        transports
        availableParsers {
          name
        }
      }
      error {
        message
      }
    }
  }
`;

/**
 * __useListAvailableLogProviders__
 *
 * To run a query within a React component, call `useListAvailableLogProviders` and pass it any options that fit your needs.
 * When your component renders, `useListAvailableLogProviders` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAvailableLogProviders({
 *   variables: {
 *   },
 * });
 */
export function useListAvailableLogProviders(
  baseOptions?: Apollo.QueryHookOptions<
    ListAvailableLogProviders,
    ListAvailableLogProvidersVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListAvailableLogProviders, ListAvailableLogProvidersVariables>(
    ListAvailableLogProvidersDocument,
    options,
  );
}
export function useListAvailableLogProvidersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListAvailableLogProviders,
    ListAvailableLogProvidersVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListAvailableLogProviders, ListAvailableLogProvidersVariables>(
    ListAvailableLogProvidersDocument,
    options,
  );
}
export function useListAvailableLogProvidersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListAvailableLogProviders,
    ListAvailableLogProvidersVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListAvailableLogProviders, ListAvailableLogProvidersVariables>(
    ListAvailableLogProvidersDocument,
    options,
  );
}
export type ListAvailableLogProvidersHookResult = ReturnType<typeof useListAvailableLogProviders>;
export type ListAvailableLogProvidersLazyQueryHookResult = ReturnType<
  typeof useListAvailableLogProvidersLazyQuery
>;
export type ListAvailableLogProvidersSuspenseQueryHookResult = ReturnType<
  typeof useListAvailableLogProvidersSuspenseQuery
>;
export type ListAvailableLogProvidersQueryResult = Apollo.QueryResult<
  ListAvailableLogProviders,
  ListAvailableLogProvidersVariables
>;
export function mockListAvailableLogProviders({
  data,
  variables,
  errors,
}: {
  data: ListAvailableLogProviders;
  variables?: ListAvailableLogProvidersVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: ListAvailableLogProvidersDocument, variables },
    result: { data, errors },
  };
}
